module.exports = __webpack_public_path__ + "static/media/blsck.c8b0374d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/blsck.svg
// module id = ./src/assets/media/blsck.svg
// module chunks = 16